import unifapImage from "./unifapImage";

// import momentjs from "moment";
let pdfMake = require("pdfmake/build/pdfmake");
let pdfFonts = require("pdfmake/build/vfs_fonts");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

function criaTabela() {
  return {
    table: {
      headerRows: 1,
      widths: ["auto", "*", "auto", "auto", "auto", "auto", "auto", "auto"],
      body: [
        [
          {
            text: "CLASS.",
            alignment: "center",
            bold: true,
          },
          {
            text: "INSCRITOS",
            alignment: "center",
            bold: true,
          },
          {
            text: "ESPECÍFICAS",
            alignment: "center",
            bold: true,
          },
          {
            text: "PORTUGUÊS",
            alignment: "center",
            bold: true,
          },
          {
            text: "GERAIS",
            alignment: "center",
            bold: true,
          },
          {
            text: "LEGISLAÇÃO",
            alignment: "center",
            bold: true,
          },
          {
            text: "TOTAL",
            alignment: "center",
            bold: true,
          },
          {
            text: "SITUAÇÃO",
            alignment: "center",
            bold: true,
          },
        ],
      ],
    },
  };
}

export default function (title, inscriptions) {
  const courses = Object.keys(inscriptions);

  //   const totalInscriptions = 0;
  let doc = {};
  let docContent = [];

  for (const course of courses) {
    docContent.push({
      text: `${course} - Ampla Concorrência`,
      fontSize: 16,
      bold: true,
    });
    let tableGeral = criaTabela();
    // let tableCotas = criaTabela();
    const inscriptionsPerCourseFormated = [];
    for (let i = 0; i < inscriptions[course].inscriptions.length; i++) {
      const inscription = inscriptions[course].inscriptions[i];
      const classification = i + 1;
      const vacancies = inscriptions[course].vacancies;
      const fontSize = 10;
      inscriptionsPerCourseFormated.push([
        { text: classification, alignment: "center", fontSize },
        { text: inscription.name, fontSize },
        { text: inscription.notaEspecifica, alignment: "center", fontSize },
        { text: inscription.notaPortugues, alignment: "center", fontSize },
        { text: inscription.notaGeral, alignment: "center", fontSize },
        { text: inscription.notaLegislacao, alignment: "center", fontSize },
        { text: inscription.total, alignment: "center", fontSize },
        {
          text:
            classification <= vacancies["Ampla Concorrência"]
              ? "CLASSIFICADO"
              : "APROVADO/NÃO CLASSIFICADO",
          alignment: "center",
          fontSize,
        },
      ]);
    }

    tableGeral.table.body.push(...inscriptionsPerCourseFormated);
    if (inscriptionsPerCourseFormated.length === 0) {
      docContent.push({
        text: "Não houve candidatos inscritos ou aprovados para essa vaga",
      });
    } else {
      docContent.push(tableGeral);
    }

    docContent.push({ text: " " });
    docContent.push({
      text: `${course} - Negros`,
      fontSize: 16,
      bold: true,
    });

    let tableNegros = criaTabela();
    let inscritosNegros = [];
    let inscNegrosFiltrado = inscriptions[course].inscriptions.filter(
      (e) => e.vacancie === "Negros"
    );
    for (let i = 0; i < inscNegrosFiltrado.length; i++) {
      const inscription = inscNegrosFiltrado[i];
      const classification = i + 1;
      const vacancies = inscriptions[course].vacancies;
      const fontSize = 10;
      inscritosNegros.push([
        { text: classification, alignment: "center", fontSize },
        { text: inscription.name, fontSize },
        { text: inscription.notaEspecifica, alignment: "center", fontSize },
        { text: inscription.notaPortugues, alignment: "center", fontSize },
        { text: inscription.notaGeral, alignment: "center", fontSize },
        { text: inscription.notaLegislacao, alignment: "center", fontSize },
        { text: inscription.total, alignment: "center", fontSize },
        {
          text:
            classification <= vacancies["Negros"]
              ? "CLASSIFICADO"
              : "APROVADO/NÃO CLASSIFICADO",
          alignment: "center",
          fontSize,
        },
      ]);
    }
    tableNegros.table.body.push(...inscritosNegros);
    if (inscritosNegros.length === 0) {
      docContent.push({
        text: "Não houve candidatos inscritos ou aprovados para essa vaga",
      });
    } else {
      docContent.push(tableNegros);
    }

    docContent.push({ text: " " });
    docContent.push({
      text: `${course} - Pessoa com Deficiência`,
      fontSize: 16,
      bold: true,
    });
    
    let tableDeficientes = criaTabela();
    let inscritosDeficientes = [];
    let inscDeficientesFiltrado = inscriptions[course].inscriptions.filter(
      (e) => e.vacancie === "Pessoa com Deficiência"
    );
    for (let i = 0; i < inscDeficientesFiltrado.length; i++) {
      const inscription = inscDeficientesFiltrado[i];
      const classification = i + 1;
      const vacancies = inscriptions[course].vacancies;
      const fontSize = 10;
      inscritosDeficientes.push([
        { text: classification, alignment: "center", fontSize },
        { text: inscription.name, fontSize },
        { text: inscription.notaEspecifica, alignment: "center", fontSize },
        { text: inscription.notaPortugues, alignment: "center", fontSize },
        { text: inscription.notaGeral, alignment: "center", fontSize },
        { text: inscription.notaLegislacao, alignment: "center", fontSize },
        { text: inscription.total, alignment: "center", fontSize },
        {
          text:
            classification <= vacancies["Pessoa com Deficiência"]
              ? "CLASSIFICADO"
              : "APROVADO/NÃO CLASSIFICADO",
          alignment: "center",
          fontSize,
        },
      ]);
    }
    tableDeficientes.table.body.push(...inscritosDeficientes);
    if (inscritosDeficientes.length === 0) {
      docContent.push({
        text: "Não houve candidatos inscritos ou aprovados para essa vaga",
      });
    } else {
      docContent.push(tableDeficientes);
    }

    docContent.push({ text: "", pageBreak: "after" });
    // totalInscriptions += inscriptionsPerCourse[course];
  }

  // let doc = {
  //   content: [
  //     {
  //       table: {
  //         headerRows: 1,
  //         widths: ["auto", "*", "auto", "auto"],
  //         body: [
  //           [
  //             {
  //               text: "CURSO",
  //               alignment: "center",
  //               bold: true,
  //             },
  //             {
  //               text: "INSCRITOS",
  //               alignment: "center",
  //               bold: true,
  //             },
  //             {
  //               text: "VAGA",
  //               alignment: "center",
  //               bold: true,
  //             },
  //             {
  //               text: "PONTUAÇÃO",
  //               alignment: "center",
  //               bold: true,
  //             },
  //           ],
  //           ...inscriptionsPerCourseFormated,
  //         ],
  //       },
  //     },
  //   ],
  // };
  doc.pageOrientation = "landscape";
  doc.pageMargins = [40, 140, 40, 60];
  doc.header = {
    margin: 10,
    alignment: "center",
    columns: [
      [
        {
          width: 20,
          image: unifapImage,
        },
        { text: "MINISTÉRIO DA EDUCAÇÃO", bold: true },
        { text: "UNIVERSIDADE FEDERAL DO AMAPÁ", bold: true },
        {
          text: "DEPARTAMENTO DE PROCESSOS SELETIVOS E CONCURSOS",
          alignment: "center",
          bold: true,
        },
        {
          text:
            "Rod. Juscelino Kubitschek Km 2, Jardim Marco Zero – Macapá-AP, CEP 68.903-419 www.unifap.br",
          fontSize: 8,
        },

        { text: " ", fontSize: 8 },
        { text: title, alignment: "center" },
        { text: "Candidatos Aprovados", alignment: "center" },
      ],
    ],
  };
  doc.content = docContent;
  pdfMake.createPdf(doc).download(`Candidatos Aprovados - ${title}.pdf`);
}
